import styles from "./AgeRestrictionMessage.module.scss";
import { DEPRECATED_Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { AgeRestriction } from "@/types/prodcatBaseTypes.ts";

export const AgeRestrictionMessageUI = ({
  minimumAge,
  bladedArticle,
}: AgeRestriction) => {
  if (!minimumAge) return null;

  return bladedArticle ? (
    <DEPRECATED_Message
      type="information"
      title={`You must be ${minimumAge} or over to buy this item`}
      body="We'll verify your age using facial age estimation at checkout."
      buttonText="How to buy and return bladed items"
      buttonProps={{
        href: "https://www.johnlewis.com/customer-services/shopping-with-us/buying-bladed-items",
        rel: "noopener noreferrer",
        tag: "a",
      }}
    />
  ) : (
    <div className={styles.ageRestrictionMessage}>
      <span className={styles.message}>
        We cannot sell this product to anyone under {minimumAge}
      </span>
    </div>
  );
};
